<div>
  <h1>404</h1>

  <h2>{{'main.404.wrong' | translate}}</h2>

  <p>{{'main.404.subtext' | translate}}</p>

  <button [routerLink]="['/']">{{'main.404.home' | translate}}</button>
</div>
